import { render, staticRenderFns } from "./DocumentDetailList31.vue?vue&type=template&id=1c2779f9&scoped=true"
import script from "./DocumentDetailList31.vue?vue&type=script&lang=js"
export * from "./DocumentDetailList31.vue?vue&type=script&lang=js"
import style0 from "./DocumentDetailList31.vue?vue&type=style&index=0&id=1c2779f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2779f9",
  null
  
)

export default component.exports